import { MarketShopInventoryItem } from '@/models'

// Note: Returns a restaurant market shop link by appending the path segment '/restaurant' to the market shop link and preserving query params (token)
export const getRestaurantMarketShopLink = (marketShopLink: string): string => {
  const [path, query] = marketShopLink.split('?')
  return `${path}/restaurant${query ? `?${query}` : ''}`
}

export const isProductHidden = (product?: MarketShopInventoryItem): boolean => {
  return !!product?.hidden
}

export const isProductOutOfStock = (product?: MarketShopInventoryItem): boolean => {
  return product?.quantity === 0 && !product?.unlimited
}
